/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

function isDefined(x) {
  return x !== undefined
}

module.exports = isDefined
